export default {
	version: state => {
		return state.version;
	},
	loading: state=>{
		return state.loading
	},
	error: state=>{
		return state.error;
	},
	valid: state=>{
		if( state.lastCall===undefined ){
			
			return undefined;
		}else if ( state.error!=null ){
			
			let {isValid=false} = state.error;
			return isValid;
		}
		let lastCall = state.lastCall;
		let valid = lastCall.isValid;
		return valid;
	},
	outdated: state=>{
		if( state.lastCall===undefined ){
			
			return undefined;
		}else if ( state.error!=null ){
			
			let {upToDate=true} = state.error;
			return !upToDate;
		}
		let {upToDate=true} = state.lastCall;
		return !upToDate;
	},
	msg: state=>{
		if( state.lastCall===undefined ){
			
			return undefined;
		}else if ( state.error!=null ){

			if( !!state.error.response ){
				switch(state.error.response.status){
					case 404:
						return 'No hemos podido encontrar la versión de la aplicación. Contacte a soporte.';
					break;
					default:
						return 'No hemos podido confirmar la versión de la aplicación. Contacte a soporte.';
				}
				
			}
			
			let lastCall = state.error;
			let {action:{msg}={}, COD_MSG} = lastCall;
			return msg;
		}
		let lastCall = state.lastCall;
		let {msg} = lastCall.action;
		return msg;
	},
	codMsgAction: state=>{
		let call = state.lastCall || state.error;
		if(!call)	return undefined;
		const {COD_MSG=undefined} = call;
		return COD_MSG;
	},
	title:state=>{
		let versionObsoleta = 'VERSIÓN OBSOLETA';
		if( state.lastCall===undefined ){
			
			return versionObsoleta;
		}else if ( state.error!=null ){

			if( !!state.error.response ){
				switch(state.error.response.status){
					case 404:
						return '¡Problemas!';
					break;
					default:
						return '¡Problemas!';
				}
				
			}
			return versionObsoleta;
		}
		return versionObsoleta;
	},
	currentAccion:state=>{
		return state.lastCall || state.error || {};
	},
	fechaAccion:(state, getters)=>{
		let {action:{fecha=undefined}={}} = getters['currentAccion'];
		return fecha;
	}
}